/**
 * Copyright 2016 xdot GmbH
 * Author: Marius Runde
 * Date: 21.04.2016
 *
 */
import { ApiUtil } from 'plugin/liferay-widgets-react-web';
import { Client } from 'external/lwr-client';

const fliwasOrganizationService = (m, o) => Client.invoke('/fliwas_structure.fliwasorganizationapi/' + m, o);
const fliwasOrganizationServiceWithContext = (m, o, c) => Client.invokeWithContext('/fliwas_structure.fliwasorganizationapi/' + m, o, c);
const administrationService = (m, o) => Client.invoke('/administration.administrationapi/' + m, o);
const administrationServiceWithContext = (m, o, c) => Client.invokeWithContext('/administration.administrationapi/' + m, o, c);

const api = {

    get(dataItem) {
        return fliwasOrganizationServiceWithContext('get.2', {
            id: dataItem.id,
            expand: 'NewestAlarmlevel,NewestManualStates'
        }, {});
    },

    listAll(query) {
        return fliwasOrganizationServiceWithContext('list-all.1', {}, {});
    },

    listFederalStates(query) {
        return fliwasOrganizationServiceWithContext('list-federal-states.1', {}, {});
    },

    search(query) {
        return fliwasOrganizationServiceWithContext('search.5', {
            start: query.start,
            end: query.end,
            searchValue: query.searchValue,
            expand: 'NewestAlarmlevel,NewestManualStates'
        }, {});
    },

    list(query) {
        return fliwasOrganizationServiceWithContext('list.3', {
            start: query.start,
            end: query.end
        }, {});
    },

    listForFederalState(query) {
        return fliwasOrganizationServiceWithContext('list-for-federal-state.1', {});
    },

    getByGroupId(query) {
        return fliwasOrganizationService('get-by-group-id.2', {
            groupId: query.id,
            expand: 'NewestAlarmlevel,NewestManualStates'
        });
    },

    getByGroupIds(query) {
        return fliwasOrganizationService('get-by-group-ids.2', {
            groupIds: query.groupIds
        });
    },

    setManualState(query) {
        return administrationServiceWithContext('set-manual-state.2', {
                classPK: query.classPK
            },
            {
                stateId: query.stateId,
                comment: query.comment,
                propName: query.propName,
                className: query.className
            });
    },

    addFliwasOrganization(item) {
        return administrationServiceWithContext('add-fliwas-organization.1', {
            'name': item.title,
            'federalState': item.federalState,
            'territoryIds': item.territoryIds,
            'administrativeRank': item.administrativeRank,
            'boundingBox': JSON.stringify(item.boundingBox),
            geometry: JSON.stringify(item.geometry),
            'type': item.type,
            situationMapGroupIds: item.situationMapGroupIds,
        });
    },

  resetGroupPermissions(groupId) {
      return administrationServiceWithContext('reset-abnormal-group-permissions.1', {
          'groupId': groupId
      }, {});
  },

    updateFliwasOrganization(item) {
        return administrationServiceWithContext('update-fliwas-organization.2', {
            'id': item.organizationId
        }, {
            'name': item.title,
            'territoryIds': item.territoryIds,
            'administrativeRank': item.administrativeRank,
            'boundingBox': JSON.stringify(item.boundingBox),
            geometry: JSON.stringify(item.geometry),
            situationMapGroupIds: item.situationMapGroupIds,
        });
    },

    getUsedTerritorialEntities() {
        return administrationService('get-used-territorial-entities.0', {});
    },

};

ApiUtil.namedApi('FliwasOrganizationWebApi', api);

export default api;



// WEBPACK FOOTER //
// ./js/webapi/FliwasOrganizationWebApi.js